import React, { Component } from 'react'
import { Route, BrowserRouter as Router } from 'react-router-dom'
import request from 'superagent'
import AgentRegister from '../component/agent_register'
import AgentRegisterNew from '../component/agent_register_new'
import ForgotPassword from '../component/forgot_password'
import Login from '../component/login'
import apis from '../helper/api'
import config from '../helper/config'
import { history } from '../helper/history'
import localdata from '../helper/localdata'
import util from '../helper/util'

const routes = [
	{
		path: '/login',
		component: Login,
	},
	{
		path: '/forgot-password',
		component: ForgotPassword,
	},
	{
		path: '/register-agent',
		component: AgentRegisterNew,
	},
]

const RouteWithSubRoutes = (route) => (
	<Route
		path={route.path}
		render={(props) => (
			<route.component
				{...props}
				routes={route.routes}
			/>
		)}
	/>
)

class LoginRegister extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false,
			device_id: '',
		}
		localdata
			.get_login_result()
			.then((payload) => {
				util.log('get_login_result: ', payload)
				if (payload.status === 'OK') {
					if (payload.results) {
						if (payload.results.session_id) {
							let type = payload.results.user_type
							if (type === 'AGENT') {
								let body = {
									session_id: payload.results.session_id,
								}
								let self = this
								request
									.post(apis.check_session)
									.set('Content-Type', 'application/json')
									.send(body)
									.end(function (err, res) {
										if (err || !res.ok) {
											// no-op
										} else {
											util.log('check-session', res)
											if (res.statusCode == 200) {
												let p = res.body
												if (p.status == 'OK') {
													if (p.results.user_id && p.results.user_id === payload.results.user_id) {
														setTimeout(() => {
															history.replace('/agen')
														}, 500)
													}
												} else {
													// no-op
												}
											}
										}
									})
							}
						}
					}
				}
			})
			.catch((err) => {
				util.log(err)
			})
	}

	componentDidMount() {
		let self = this
		if (util.is_electron()) {
			window.ipcRenderer.on('rpc-response', (event, arg) => {
				util.log('rpc-response', arg)
				if (arg.method === 'get_uuid') {
					self.setState({ device_id: arg.return })
					localdata
						.set_property('device_id', arg.return)
						.then((res) => {
							util.log('set property device_id: ', res)
						})
						.catch((err) => {
							util.log(err)
						})
				}
			})
			let params = { method: 'get_uuid' }
			util.log('rpc-request', params)
			window.ipcRenderer.send('rpc-request', params)
		}
	}

	truncate(fullStr, strLen, separator) {
		if (fullStr.length <= strLen) return fullStr
		separator = separator || '...'
		var sepLen = separator.length,
			charsToShow = strLen - sepLen,
			frontChars = Math.ceil(charsToShow / 2),
			backChars = Math.floor(charsToShow / 2)
		return fullStr.substr(0, frontChars) + separator + fullStr.substr(fullStr.length - backChars)
	}

	copyToClipboard(text) {
		if (window.clipboardData && window.clipboardData.setData) {
			return window.clipboardData.setData('Text', text)
		} else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
			var textarea = document.createElement('textarea')
			textarea.textContent = text
			textarea.style.position = 'fixed' // Prevent scrolling to bottom of page in MS Edge.
			document.body.appendChild(textarea)
			textarea.select()
			try {
				return document.execCommand('copy') // Security exception may be thrown by some browsers.
			} catch (ex) {
				console.warn('Copy to clipboard failed.', ex)
				return false
			} finally {
				document.body.removeChild(textarea)
			}
		}
	}

	render() {
		let body_contact_admin = '%0A%0A%0Aug: ' + navigator.userAgent
		let app_version = config.app_version
		if (util.is_electron()) {
			app_version = util.get_desktop_version()
		}
		const currentDate = new Date();
		const fullYear = currentDate.getFullYear()
		return (
			<Router>
				<div
					className="m-grid m-grid--hor m-grid--root m-page"
					style={{ height: '-webkit-fill-available' }}
				>
					{routes.map((route, i) => (
						<RouteWithSubRoutes
							key={i}
							{...route}
						/>
					))}
					<footer
						className="m-grid__item m-footer"
						style={{ boxShadow: 'none', background: 'none', position: 'fixed', bottom: 0, right: 0, padding: '7px 10px' }}
					>
						<div
							className="m-container m-container--fluid m-page__container"
							style={{ width: '300px', right: 0, marginRight: 'unset' }}
						>
							<div className="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
								<div className="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
									<ul
										className="m-footer__nav m-nav m-nav--inline m--pull-right"
										style={{ width: 'max-content' }}
									>
										<li className="m-nav__item m-nav__item">
											<a className="m-nav__link">
												<span
													className="m-footer__copyright"
													style={{ verticalAlign: 'middle', display: 'table-cell', lineHeight: '13px' }}
												>
													{this.state.device_id.length !== 0 ? (
														<React.Fragment>
															<span
																style={{ fontWeight: 600, lineHeight: '15px', cursor: 'pointer' }}
																onClick={(e) => this.copyToClipboard(this.state.device_id.toUpperCase())}
															>
																DEVICE ID: {this.truncate(this.state.device_id.toUpperCase(), 30)}
															</span>
															<br />
														</React.Fragment>
													) : (
														''
													)}
													{app_version} {fullYear} &copy; PT POS INDONESIA
												</span>
											</a>
										</li>
										<li className="m-nav__item m-nav__item">
											<a
												href={'mailto:' + config.helpdesk_email + '?body=' + body_contact_admin}
												target="_top"
												data-container="body"
												className="m-nav__link"
												title="Customer Service"
												data-placement="login"
												style={{ cursor: 'pointer' }}
											>
												<i
													className="m-nav__link-icon flaticon-info"
													style={{ fontSize: '25px' }}
												></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</footer>
				</div>
			</Router>
		)
	}
}

export default LoginRegister
